import React, { useState, useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
  inputFields,
} from "../../shared/enums/candidates_enum";
import DataTable from "../../components/common/DataTable";
import {
  useAllCandidates,
  useGetDropdownOptions,
  useAllCandidatesStats,
} from "../../shared/hooks/UseCandidate";
import SidebarFilter from "../../components/common/SidebarFilter";
import { Link } from "react-router-dom";
import FilterDateComponent from "../../components/common/FilterDateComponent";
import { UseDataForExcel, UseFilter } from "../../shared/hooks/UseExcel";
import ExportComponent from "../../components/common/ExportComponent";
import { useSelector } from "react-redux";


const AllCandidates = ({ }) => {
  const [data, setPageNumber, deleteBtnClicked] = useAllCandidates();
  const [statsdata, setParams] = useAllCandidatesStats();

  const {
    loading,
    candidates,
    total_candidates,
    candidates_stats_loading,
    candidates_stats,
    page,
    pages,
  } = data;

  const [
    dropdownOptions,
    setClientSearchField,
    setClientSearchValue
  ] = useGetDropdownOptions();

  const loadOptions = async (inputValue, callback, field) => {
    if (field == "client_name") {
      await setClientSearchField("name");
      await setClientSearchValue(inputValue);
      callback(dropdownOptions.client_name);
    }
  };

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (candidates) {
      convertToReadable(candidates, inputFields);
    }
  }, [candidates]);

  const handleOnExport = () => {
    exportXLSXData(exportData, "Candidates", "candidates");
  };
  console.log("CANDIDATE STATS", candidates_stats);
  console.log(" SIDEBAR_OPTIONS -", SIDEBAR_OPTIONS)


  const userData = useSelector((state) => state.auth);
  const { user } = userData;
  return (
    <div className="pace-done">
      <div>
        <Header />

        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        <FilterDateComponent link="/candidates"
          showOwn={true}
          label="My Candidates"
          searchParams={{ term: "recruiter", value: user._id }}

        />
        <div className="container-fluid">
          <div className="row">
            {SIDEBAR_OPTIONS && (
              <SidebarFilter
                SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
                dropdown_options={dropdownOptions}
                loadOptions={loadOptions}

              />
            )}

            <div className="col-lg-9">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item={LINK_URL} title={PAGE_SINGLE_TITLE} />
                  <div className="row">
                    <div className="col-md-2">
                      {total_candidates} records found
                    </div>
                    {candidates_stats &&
                      candidates_stats.map((item) => {
                        if (item._id) {
                          return (
                            <div className="col-md-2">
                              <div className="card">
                                <div className="card-body">
                                  <Link to={`/candidates?exact[candidate_status]=${item._id}`}>
                                    <div>{item._id}</div>
                                  </Link>
                                  <Link to={`/candidates?exact[candidate_status]=${item._id}`}>
                                    <div> {item.count} </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          );
                        }

                      })}
                  </div>
                  <div>
                    <Link
                      to={"/candidates/cvimport"}
                      className="btn btn-success"
                    >
                      Import CV
                    </Link>
                  </div>

                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={candidates}
                      field={LINK_URL}
                      page={page}
                      deleteBtnClicked={deleteBtnClicked}
                      loading={loading}
                      inputFields={inputFields}
                      PAGE_TITLE={PAGE_TITLE}
                      PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
                    />
                    <Pagination
                      data={candidates}
                      page={page}
                      pages={pages}
                      count={total_candidates}
                      setPage={setPageNumber}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllCandidates;
